(() => {
  const instances = new WeakMap();
  function init(root) {
    if (instances.has(root)) return;
    const aborter = new AbortController();
    const { signal } = aborter;
    const tabs = [...root.querySelectorAll('[data-mode-tab]')];
    const panels = [...root.querySelectorAll('[data-mode-panel]')];
    const svgs = [...root.querySelectorAll('[data-mode-svg]')];
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const toggle = root.querySelector('[data-motion-toggle]');
    let current = 'static';
    let wantsMotion = !motion.matches;
    let modesVisible = false;
    function syncMotion() {
      svgs.forEach(svg => {
        const selected = svg.closest('[data-mode-panel]').dataset.modePanel === current;
        const animated = !motion.matches && typeof svg.pauseAnimations === 'function';
        svg.toggleAttribute('data-animated', animated);
        if (animated && wantsMotion && selected && modesVisible && !document.hidden) svg.unpauseAnimations();
        else if (typeof svg.pauseAnimations === 'function') svg.pauseAnimations();
      });
      toggle.hidden = motion.matches || !svgs.some(svg => typeof svg.pauseAnimations === 'function');
      toggle.textContent = wantsMotion ? 'Pause animation' : 'Play animation';
    }
    function selectMode(mode, focus = false) {
      current = mode;
      tabs.forEach(tab => {
        const selected = tab.dataset.modeTab === mode;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        if (selected && focus) tab.focus();
      });
      panels.forEach(panel => {
        const selected = panel.dataset.modePanel === mode;
        panel.hidden = !selected;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tabs.find(tab => tab.dataset.modeTab === panel.dataset.modePanel).id);
        panel.tabIndex = 0;
        const svg = panel.querySelector('svg');
        if (selected && typeof svg.setCurrentTime === 'function') svg.setCurrentTime(0);
      });
      syncMotion();
    }
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => selectMode(tab.dataset.modeTab), { signal });
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) {
          event.preventDefault();
          selectMode(tabs[next].dataset.modeTab, true);
        }
      }, { signal });
    });
    root.querySelector('[data-mode-tabs]').hidden = false;
    toggle.addEventListener('click', () => { wantsMotion = !wantsMotion; syncMotion(); }, { signal });
    motion.addEventListener('change', () => { wantsMotion = !motion.matches; syncMotion(); }, { signal });
    document.addEventListener('visibilitychange', syncMotion, { signal });
    selectMode(current);
    const sticky = root.querySelector('[data-sticky-cta]');
    const hero = root.querySelector('.pg-hero');
    const bundle = root.querySelector('#the-bundle');
    const footer = root.querySelector('.pg-footer');
    let heroPassed = false;
    let bundleVisible = false;
    let footerVisible = false;
    const observer = typeof IntersectionObserver === 'function' ? new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (entry.target === hero) heroPassed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        else if (entry.target === bundle) bundleVisible = entry.isIntersecting;
        else if (entry.target === footer) footerVisible = entry.isIntersecting;
        else modesVisible = entry.isIntersecting;
      }
      sticky.hidden = !(heroPassed && !bundleVisible && !footerVisible);
      syncMotion();
    }, { threshold: 0 }) : null;
    if (observer) [hero, bundle, footer, root.querySelector('#explore-modes')].forEach(element => observer.observe(element));
    else { modesVisible = true; syncMotion(); }
    instances.set(root, () => { aborter.abort(); observer?.disconnect(); svgs.forEach(svg => svg.pauseAnimations?.()); instances.delete(root); });
  }
  function mount(scope = document) { scope.querySelectorAll('[data-pump-guide]').forEach(init); }
  mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-pump-guide]').forEach(root => instances.get(root)?.()));
})();
